// Changelog entries. Newest first.
// Add new items at the top with a unique id. Viewing the What's New modal marks them seen.

export const WHATS_NEW = [
  {
    id: '2026-10-15-inventory-samples',
    date: '2026-10-15',
    title: 'Inventory skips JQ- and SP- too',
    body: 'On Inventory, the sample-orders checkbox now skips orders starting with JQ- and SP- in addition to DYNO, since those are samples, not sales.'
  },
  {
    id: '2026-10-01-inventory-coverage',
    date: '2026-10-01',
    title: 'Inventory months left',
    body: 'Inventory uses Fulfillrite stock and Fulfillrite orders. Pick last year or last 6 months, optionally skip orders that start with DYNO, and sort so the fewest months of stock are at the top. Rows under six months of stock pulse scarlet.'
  },
  {
    id: '2026-09-17-wish-tags-contacts-back',
    date: '2026-09-17',
    title: 'Wish teammates + contacts search sticks',
    body: 'Wishes can tag extra Chibi people (besides the main assignee) so the wish also shows on My wishes for them. Contacts search now stays put when you open someone and hit Back.'
  },
  {
    id: '2026-09-08-last-email-split',
    date: '2026-09-08',
    title: 'They emailed us / we emailed them',
    body: 'Last contact on a person is now two dates: last time they emailed a Chibi person, and last time a Chibi person emailed them. New contacts look up past Gmail, not just mail from the day you added them.'
  },
  {
    id: '2026-08-13-orders-warehouse',
    date: '2026-08-13',
    title: 'Contact orders load instantly',
    body: 'Orders on a contact now come from our local warehouse instead of live Shopify/Fulfillrite calls. The warehouse refreshes twice a day with the rest of the ETL.'
  },
  {
    id: '2026-08-13-order-to-contact',
    date: '2026-08-13',
    title: 'Order number jumps to the contact',
    body: 'On Dashboard → Orders, click an order number to open that person and land on their Orders tab with the matching order highlighted.'
  },
  {
    id: '2026-08-12-contacts-my-all',
    date: '2026-08-12',
    title: 'All contacts / My contacts',
    body: 'The Contacts list now has All contacts and My contacts (people assigned to you as Chibi contact). All contacts is the default.'
  },
  {
    id: '2026-08-12-estimate-pdf-dash',
    date: '2026-08-12',
    title: 'Estimate PDFs: DASH numbers, no conduit',
    body: 'Customer-facing estimate PDFs now use a DASH prefix on the number (e.g. DASH1001) and no longer show conduit steps — those stay internal.'
  },
  {
    id: '2026-08-12-contact-status-last-contact',
    date: '2026-08-12',
    title: 'Contact status + last email',
    body: 'On a contact, Life cycle (Prospect / Lead / Customer / Advocate) and Lead status are dropdowns. Last contact is the latest email either way with anyone @chibitronics.com. Orders now show deliver-to name, org, and address.'
  },
  {
    id: '2026-07-20-discount-percent',
    date: '2026-07-20',
    title: 'Estimate discount by %',
    body: 'When creating an estimate or order, discount can be a percentage or a dollar amount. Percentage is the default; toggle to $ if you prefer a fixed amount.'
  },
  {
    id: '2026-07-20-starred-tab-order',
    date: '2026-07-20',
    title: 'Starred tabs reshuffled',
    body: 'On Starred → Contacts, the order is now Assigned to me, My stars, then All stars — so your own stuff comes first.'
  },
  {
    id: '2026-07-20-wishes-mine-first',
    date: '2026-07-20',
    title: 'My wishes first',
    body: 'On the Wishes page, My wishes comes before All wishes — and opens there by default.'
  },
  {
    id: '2026-07-20-starred-orgs',
    date: '2026-07-20',
    title: 'Starred organizations',
    body: 'Star an organization from Companies or its detail page, then find it on Starred → Organizations. Companies also has a Starred Companies shortcut.'
  },
  {
    id: '2026-07-20-jenny-chibi-contact',
    date: '2026-07-20',
    title: 'Jenny on Chibi contact',
    body: 'Jenny is now in the Chibi contact dropdown (contacts, wishes, estimates). Welcome!'
  },
  {
    id: '2026-07-20-conduit',
    date: '2026-07-20',
    title: 'Conduit & Estimates',
    body: 'Estimates is now Conduit & Estimates. Track each opportunity from connection (1) through purchase order (5), assign a Chibitronics Contact, and see pipeline totals on the ledger, contact pages, and organization pages.'
  },
  {
    id: '2026-07-20-estimates-ledger',
    date: '2026-07-20',
    title: 'Estimates ledger',
    body: 'On Estimates, open the Ledger tab to see every estimate and custom order across contacts — search, filter, open PDFs, or delete — without hopping contact by contact.'
  },
  {
    id: '2026-07-20-estimate-delete-pdf',
    date: '2026-07-20',
    title: 'Estimates: delete + PDF fix',
    body: 'You can delete an estimate from a contact\'s Estimates tab. Also fixed PDFs that crashed on long billing or shipping addresses.'
  },
  {
    id: '2026-07-14-email-import-undo',
    date: '2026-07-14',
    title: 'Undo email import',
    body: 'After you import sent emails as notes, you get an Undo last import button. Imported email bodies are also readable on the dark theme now.'
  },
  {
    id: '2026-07-12-org-email-to',
    date: '2026-07-12',
    title: 'Org email defaults to To',
    body: 'Organization-wide email now puts everyone in To by default. Check the box if you want Bcc instead.'
  },
  {
    id: '2026-07-12-email-notes-fix',
    date: '2026-07-12',
    title: 'Sent mail sticks to Notes',
    body: 'Emails you send from Dashamajig land in Notes as Email entries (not wishes). After you send, it jumps you to the Notes tab so you can see it right away.'
  },
  {
    id: '2026-07-11-assigned-starred',
    date: '2026-07-11',
    title: 'Assigned to me on Starred',
    body: 'Starred now has All starred, My starred, and Assigned to me. You also get an Assigned column so you can see who owns the relationship.'
  },
  {
    id: '2026-07-11-org-detail',
    date: '2026-07-11',
    title: 'Organization pages',
    body: 'Click a company and you get a real org view, not just a contacts filter. Profile fields, people list, the works.'
  },
  {
    id: '2026-07-11-org-email',
    date: '2026-07-11',
    title: 'Email a whole organization',
    body: 'From an org page, email everyone currently there. Everyone starts checked. Uncheck anyone you want to skip, then compose.'
  },
  {
    id: '2026-07-11-former',
    date: '2026-07-11',
    title: 'Former coworkers',
    body: 'Mark someone as former on an org page when they no longer work there. They stay on the record under Former, and you can restore them.'
  },
  {
    id: '2026-07-11-tag-mass',
    date: '2026-07-11',
    title: 'Mass tag from a tag list',
    body: 'When you edit a tagged list, you can add or remove that whole selected crew from other tags in one shot.'
  },
  {
    id: '2026-07-11-star-owners',
    date: '2026-07-11',
    title: 'Who starred what',
    body: 'Going forward, stars remember who clicked them. My starred is yours. All starred is everyone, including older stars from before we tracked ownership.'
  },
  {
    id: '2026-07-11-wish-tabs',
    date: '2026-07-11',
    title: 'Wish archive tabs reshuffled',
    body: 'Completed comes first in garden green. Paused sits next to it in crimson. Open wishes still skip paused ones.'
  },
  {
    id: '2026-07-11-gmail-notes',
    date: '2026-07-11',
    title: 'Gmail send lands in Notes',
    body: 'Emails you send from a contact now show up as notes, with attachments supported. You can also import earlier sent mail as notes.'
  },
  {
    id: '2026-07-11-whats-new',
    date: '2026-07-11',
    title: 'This orb',
    body: 'Yeah. The glowing thing in the corner. That is how you find what shipped since you last looked.'
  }
]

export const WHATS_NEW_IDS = WHATS_NEW.map((f) => f.id)
